import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetUserChatTokenResponseApi } from "@interfaces/IGetUserChatTokenResponseApi.ts"
import { IGetUserChatTokenResponseCli } from "@interfaces/IGetUserChatTokenResponseCli.ts"

export const GetUserChatTokenAdapter = (
	response: IApiResponse<IGetUserChatTokenResponseApi>
): IGetUserChatTokenResponseCli => {
	return response.data
}
